var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"traction-wrapper"},[_c('div',{staticClass:"wrapper"},[_c('tiptap',{attrs:{"text":_vm.tractions,"id":'tractopn-content'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }